<template>
  <div class="-format-input -hex">
    <span>HEX</span>
    <input
      type="text"
      class="wt2-text-m wt2-color-negative"
      spellcheck="false"
      v-select-on-click
      :value="hex"
      @change="update"
    />
  </div>
</template>

<script>
export default {
  props: {
    hex: {
      type: String,
      required: true,
    },

    isValid: {
      type: Function,
      required: true,
    },
  },

  methods: {
    isValidate(hex) {
      return this.isValid(hex);
    },

    update(e) {
      const value = e.target.value;
      this.isValidate(value)
        ? this.$emit('update-hex', value)
        : // force update to replace the un validated value
          // with the current rgb value
          this.$forceUpdate();
    },
  },
};
</script>
